import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { IconNames } from '../../common';

@Component({
  selector: 'ui-carrier-select',
  templateUrl: './carrier-select.component.html',
  styleUrls: ['./carrier-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
// eslint-disable-next-line id-blacklist
export class CarrierSelectComponent<T extends { extId: string; name: string; number: string }> {
  @Input() carriers: T[];
  @Input() fieldControl: FormControl<T>;
  @Input() fieldLabel: string;
  @Input() testId: string;
  @Input() disableField = false;
  @Input() isLoadMoreEnabled: boolean;
  @Input() loadMoreAmount = 10;

  @Output() optionSelected: EventEmitter<T> = new EventEmitter();
  @Output() loadMore: EventEmitter<{ searchTerm: string; more: number; optionAmount: number }> = new EventEmitter();
  @Output() search: EventEmitter<string> = new EventEmitter();

  searchTerm = '';
  iconNames = IconNames;

  onOptionSelected(event: MatAutocompleteSelectedEvent): void {
    this.optionSelected.emit(event.option.value);
  }

  onLoadMore(): void {
    const optionAmount = this.carriers?.length || 0;

    this.loadMore.emit({ searchTerm: this.searchTerm, more: this.loadMoreAmount, optionAmount });
  }

  searchFn(searchEvent: InputEvent): void {
    const inputElement = searchEvent.target as HTMLInputElement;
    const term = inputElement.value;
    this.searchTerm = term;
    this.search.emit(term);
  }

  displayValueFn(carrierName: string): string {
    return carrierName || '';
  }
}
